import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconRoomCalendar: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        d="M13.3967 1.66699H16.2183C17.3869 1.66699 18.3338 2.62187 18.3338 3.80029V6.64576C18.3338 7.82419 17.3869 8.77907 16.2183 8.77907H13.3967C12.2281 8.77907 11.2812 7.82419 11.2812 6.64576V3.80029C11.2812 2.62187 12.2281 1.66699 13.3967 1.66699Z"
        fill="#200E32"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.78243 1.66699H6.60407C7.77262 1.66699 8.7195 2.62187 8.7195 3.80029V6.64576C8.7195 7.82419 7.77262 8.77907 6.60407 8.77907H3.78243C2.61387 8.77907 1.66699 7.82419 1.66699 6.64576V3.80029C1.66699 2.62187 2.61387 1.66699 3.78243 1.66699ZM3.78243 11.2216H6.60407C7.77262 11.2216 8.7195 12.1765 8.7195 13.3549V16.2004C8.7195 17.378 7.77262 18.3337 6.60407 18.3337H3.78243C2.61387 18.3337 1.66699 17.378 1.66699 16.2004V13.3549C1.66699 12.1765 2.61387 11.2216 3.78243 11.2216ZM16.2182 11.2216H13.3966C12.228 11.2216 11.2811 12.1765 11.2811 13.3549V16.2004C11.2811 17.378 12.228 18.3337 13.3966 18.3337H16.2182C17.3868 18.3337 18.3337 17.378 18.3337 16.2004V13.3549C18.3337 12.1765 17.3868 11.2216 16.2182 11.2216Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconRoomCalendar;
